<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header alert" v-bind:class="{'alert-info' : confirm.success, 'alert-danger' : !confirm.success}">
                        <h5 role="alert" class="modal-title" id="commandAlertLabel">{{confirm.title}}</h5>
                        <button type="button" class="close" @click="$emit('close')" data-dismiss="modal"
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="typeof confirm.msg === 'string'">
                            <p class="d-block">{{confirm.msg}}</p>
                        </template>
                        <template v-else>
                            <ul>
                            <template v-for="msgs in confirm.msg">
                                <li v-for="msg in msgs">
                                    {{msg}}
                                </li>
                            </template>
                            </ul>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
  export default {
    props: {
      confirm: Object,
    },
  }
</script>